export const COMPANY_INFO = {
  brandName: "K-TO Ventilationsteknik",
  logo: "https://assets.auxodev.dk/cdn-cgi/image/width=200,quality=90,format=auto/assets/379e2bd1-51e7-4436-a4bf-bf31d3b287e1/307918904-1145084119439492-2392609862970934347-n.jpg",
  logoOriginal: "https://assets.auxodev.dk/assets/379e2bd1-51e7-4436-a4bf-bf31d3b287e1/307918904-1145084119439492-2392609862970934347-n.jpg",
  legalName: "K-TO Multiservice ApS",
  address: "Andkær Bygade 24",
  zipCity: "7080 Børkop",
  fullAddress: "Andkær Bygade 24, 7080 Børkop",
  phone: "(+45) 22 72 87 23",
  phoneRaw: "+4522728723",
  email: "k-to@outlook.dk",
  invoiceEmail: "faktura.k-to@outlook.dk",
  cvr: "39013630",
  experienceYears: "30",
  coverageRegions: "Fyn og hele Jylland",
  primaryCities: ["Vejle", "Fredericia", "Kolding"]
};

export const SERVICES_LIST = [
  {
    name: "Service",
    slug: "service-og-ventilation",
    icon: "fa-solid fa-wrench-simple",
    shortDesc: "Vi tilbyder alle slags services af mindre køleanlægstyper og ventilationsanlæg, så dit anlæg kan bruges i mange år frem.",
    image: "https://assets.auxodev.dk/assets/379e2bd1-51e7-4436-a4bf-bf31d3b287e1/ventilationservice-7-1024x683.jpg",
    metaTitle: "Service af ventilationsanlæg | Vejle & omegn | Kontakt os ✆",
    metaDescription: "Service af ventilationsanlæg til Vejle og omegn ✓ Din professionelle ekspert til udførelse af service og ventilationsopgaver ✓ Ring nu på tlf. 22 72 87 23",
    ogImage: "https://assets.auxodev.dk/assets/379e2bd1-51e7-4436-a4bf-bf31d3b287e1/ventilationservice-7-1024x683.jpg"
  },
  {
    name: "Indregulering og lydregulering",
    slug: "indregulering",
    icon: "fa-solid fa-sliders",
    shortDesc: "Det er vigtigt, at et ventilationsanlæg bliver indreguleret, så der er balance mellem udsugning og indblæsning.",
    image: "https://assets.auxodev.dk/assets/379e2bd1-51e7-4436-a4bf-bf31d3b287e1/ventilationservice-2-1024x683.jpg",
    metaTitle: "Indregulering af ventilation | Ring til K-TO Multiservice",
    metaDescription: "Indregulering af ventilation tilbydes | Indregulering af ventilationsanlæg & diverse ydelser | Vi tilbyder alt inden for ventilation & service | Kontakt os",
    ogImage: "https://assets.auxodev.dk/assets/379e2bd1-51e7-4436-a4bf-bf31d3b287e1/ventilationservice-2-1024x683.jpg"
  },
  {
    name: "Fejlfinding og reparation",
    slug: "fejlfinding-og-reparation",
    icon: "fa-solid fa-stethoscope",
    shortDesc: "Der kan forekomme forskellige slags problemer på et anlæg, som vi selvfølgelig løser professionelt og kompetent for dig.",
    image: "https://assets.auxodev.dk/assets/379e2bd1-51e7-4436-a4bf-bf31d3b287e1/307918904-1145084119439492-2392609862970934347-n.jpg",
    metaTitle: "Reparation af ventilationsanlæg | K-TO Multiservice",
    metaDescription: "Vi tilbyder reparation af ventilationsanlæg | K-TO Multiservice tilbyder opgaver inden for fejlfinding og reparation af ventilationsanlæg | Kontakt os her",
    ogImage: "https://assets.auxodev.dk/assets/379e2bd1-51e7-4436-a4bf-bf31d3b287e1/307918904-1145084119439492-2392609862970934347-n.jpg"
  },
  {
    name: "Salg og montering",
    slug: "salg-og-montering",
    icon: "fa-solid fa-screwdriver-wrench",
    shortDesc: "Salg af ventilationskomponenter og anlæg samt faglig montering og opstart.",
    image: "https://assets.auxodev.dk/assets/379e2bd1-51e7-4436-a4bf-bf31d3b287e1/ventilation-montage.jpg"
  },
  {
    name: "Rensning af ventilationsanlæg",
    slug: "rensning-af-ventilation",
    icon: "fa-solid fa-filter",
    shortDesc: "Hos K-TO Multiservice tilbyder vi rengøring og rensning af ventilationsanlæg.",
    image: "https://assets.auxodev.dk/assets/379e2bd1-51e7-4436-a4bf-bf31d3b287e1/ventilationservice-9-1024x1024.jpg",
    metaTitle: "Rensning af ventilationsanlæg og -kanaler | Kontakt os",
    metaDescription: "Rensning af ventilationsanlæg tilbydes | K-To Multiservice tilbyder rengøring & rensning af ventilationsanlæg | Kontakt os & få et uforpligtende tilbud",
    ogImage: "https://assets.auxodev.dk/assets/379e2bd1-51e7-4436-a4bf-bf31d3b287e1/ventilationservice-9-1024x1024.jpg"
  },
  {
    name: "Køl og aircondition",
    slug: "kol",
    icon: "fa-solid fa-snowflake",
    shortDesc: "Hos K-TO Multiservice tilbyder vi montage og service inden for mindre køleanlæg og ventilationsanlæg.",
    image: "https://assets.auxodev.dk/assets/379e2bd1-51e7-4436-a4bf-bf31d3b287e1/ventilationservice-6-1024x683.jpg",
    metaTitle: "Vi monterer og servicer mindre køleanlæg | K-TO | Se mere her →",
    metaDescription: "Servicerer mindre køleanlæg | K-TO kan servicere alle mindre køleanlægstyper. Uforpligtende tilbud gives. Ring på telefon 22 72 87 23.",
    ogImage: "https://assets.auxodev.dk/assets/379e2bd1-51e7-4436-a4bf-bf31d3b287e1/ventilationservice-6-1024x683.jpg"
  },
  {
    name: "Varmepumper",
    slug: "varmepumper",
    icon: "fa-solid fa-temperature-arrow-up",
    shortDesc: "Installation, service, fejlfinding og vedligeholdelse af luft-til-luft varmepumper til erhverv og industri.",
    image: "https://assets.auxodev.dk/assets/379e2bd1-51e7-4436-a4bf-bf31d3b287e1/heat-pump-industrial.jpg"
  }
];

export const NAV_LINKS = [
  { label: "Forside", href: "/" },
  { label: "K-TO Ventilationsteknik", href: "/k-to-ventilationsteknik" },
  {
    label: "Ydelser",
    href: "/ydelser/service-og-ventilation",
    children: [
      { label: "Service", href: "/ydelser/service-og-ventilation" },
      { label: "Indregulering og lydregulering", href: "/ydelser/indregulering" },
      { label: "Fejlfinding og reparation", href: "/ydelser/fejlfinding-og-reparation" },
      { label: "Salg og montering", href: "/ydelser/salg-og-montering" },
      { label: "Rensning af ventilationsanlæg", href: "/ydelser/rensning-af-ventilation" },
      { label: "Køl og aircondition", href: "/ydelser/kol" },
      { label: "Varmepumper", href: "/ydelser/varmepumper" }
    ]
  },
  { label: "Erhverv og industri", href: "/erhverv-og-industri" },
  { label: "Galleri", href: "/galleri" },
  { label: "Kontakt", href: "/kontakt" }
];
